import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../globals';
import Loader from '../../../generic/Loader';
import { getCurrentPlanType } from '../utils';

import FullFeatureTable from './featuresTable';
import PlanCards from './PlanCards';
import { usePlansContext } from './PlansContext';
import PlansHeader from './PlansHeader';

export type ViewIntervalOptions = 'month' | 'year';

const Plans: VoidFunctionComponent = () => {
  const {
    plans,
    isLoading,
  } = usePlansContext();

  if (isLoading) {
    return (<Loader />);
  }

  if (!plans) {
    return null;
  }

  const org = window?.user?.organization;
  if (!org) {
    return null;
  }
  const currentPlanType = getCurrentPlanType(org);

  return (
    <>
      <PlansHeader />
      <PlanCards />
      <FullFeatureTable currentPlanType={currentPlanType} />
    </>
  );
};

export default Plans;
